// Resource Upload AJAX handling
export function initResourceUpload() {
    const form = document.getElementById('upload-resource-form');
    if (!form) return;

    const submitButton = document.getElementById('submit-button');
    if (!submitButton) return;

    const submitText = submitButton.querySelector('.submit-text');
    const spinner = submitButton.querySelector('.spinner-border');
    const messageContainer = document.getElementById('upload-message-container');

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Basic client-side validation for files (if not editing)
        const isEdit = form.querySelector('input[name="resource_id"]').value !== '';
        if (!isEdit) {
            const fileInput = form.querySelector('input[name="resource_file"]');
            const previewInput = form.querySelector('input[name="file_preview"]');
            if (fileInput && previewInput && (fileInput.files.length === 0 || previewInput.files.length === 0)) {
                displayMessage('Please select both a resource file and a preview image.');
                return;
            }
        }

        // Show loading state
        submitButton.disabled = true;
        if (submitText) submitText.style.opacity = '0.5';
        if (spinner) spinner.classList.remove('d-none');

        const formData = new FormData(form);
        formData.append('action', 'upload_resource_ajax');

        fetch(api_settings.ajax_url, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    window.location.href = data.data.redirect;
                } else {
                    // Handle error
                    displayMessage(data.data.message || 'An error occurred during upload.');
                    resetButton();
                }
            })
            .catch(error => {
                console.error('Error:', error);
                displayMessage('An unexpected error occurred.');
                resetButton();
            });
    });

    function displayMessage(msg) {
        if (!messageContainer) return;
        messageContainer.innerHTML = `<div class="alert alert-danger alert-dismissible fade show mt-3" role="alert">
            <strong>${msg}</strong>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>`;
        messageContainer.scrollIntoView({ behavior: 'smooth' });
    }

    function resetButton() {
        submitButton.disabled = false;
        if (submitText) submitText.style.opacity = '1';
        if (spinner) spinner.classList.add('d-none');
    }
}
